import { render } from "./SFaceCheckinDateTime.vue?vue&type=template&id=c881c05e&scoped=true"
import script from "./SFaceCheckinDateTime.vue?vue&type=script&lang=js"
export * from "./SFaceCheckinDateTime.vue?vue&type=script&lang=js"

import "./SFaceCheckinDateTime.vue?vue&type=style&index=0&id=c881c05e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c881c05e"

export default script